import React, { useEffect, useRef } from "react";
import "./index.scss";
import { HMS } from "../../constants/function";
import { useDispatch, useSelector } from "react-redux";
import { updatecount } from "../../action/adv";
import { Typography } from "@mui/material";

var timerId;
export default function ImageAdv({ url, type, href, time }) {
  const rangeRef = useRef();
  const dispatch = useDispatch();
  const [seconds, setSeconds] = React.useState(time);
  const [progress, setProgress] = React.useState(0);
  const { index, songs, track, prevIndex, pos } = useSelector(
    (state) => state.streamSong
  );

  useEffect(() => {
    if (seconds > 0) {
      const timerId = setTimeout(() => {
        setSeconds(seconds - 1);
      }, 1000);
    }
    if (seconds === 0) {
      dispatch(updatecount(0));
    }
    return () => clearTimeout(timerId);
  }, [seconds]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 100) {
          return 0;
        }
        const diff = (1 * 10) / 3;
        return Math.min(oldProgress + diff, 100);
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, []);
  // console.log(time, "::Timee::");
  return (
    <div className="container">
      {type === "image" ? (
        <div className="img_time">
          <Typography
            className="fs-20"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {`${HMS(seconds)}` === "0 sec" ? "00 : 00" : `${HMS(seconds)}`}
          </Typography>
        </div>
      ) : null}
      <a href={href} target="_blank" className="img_ancer">
        <img src={url} alt="advertisement_Img" className="gif_img" />
        <div className="bottom">
          <input
            type="range"
            name="range"
            id="myProgressBar"
            min="0"
            max="100"
            value={progress}
            ref={rangeRef}
            style={{ height: "3px" }}
          />
        </div>
        <div className="img_transferent"></div>
      </a>
    </div>
  );
}
